module.exports = __webpack_public_path__ + "static/img/bianzu0.78572c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bianzu0.png
// module id = K8U4
// module chunks = 2